const GET_REQUEST_MESSAGES_REQUEST = 'GET_REQUEST_MESSAGES_REQUEST';
const GET_REQUEST_MESSAGES_COMPLETE = 'GET_REQUEST_MESSAGES_COMPLETE';
const GET_REQUEST_MESSAGES_ERROR = 'GET_REQUEST_MESSAGES_ERROR';

const SEND_REQUEST_MESSAGE_REQUEST = 'SEND_REQUEST_MESSAGE_REQUEST';
const SEND_REQUEST_MESSAGE_COMPLETE = 'SEND_REQUEST_MESSAGE_COMPLETE';
const SEND_REQUEST_MESSAGE_ERROR = 'SEND_REQUEST_MESSAGE_ERROR';

export default {
  GET_REQUEST_MESSAGES_REQUEST,
  GET_REQUEST_MESSAGES_COMPLETE,
  GET_REQUEST_MESSAGES_ERROR,
  SEND_REQUEST_MESSAGE_REQUEST,
  SEND_REQUEST_MESSAGE_COMPLETE,
  SEND_REQUEST_MESSAGE_ERROR
}
